module.exports = __webpack_public_path__ + "static/media/contact-desktop.ed560d7f.jpg";